// Mock content data for Nishit Thakkar website
// Mirrors the digitaldhairya.com structure adapted to a money-manifestation consulting brand

export const SITE = {
  brandTop: 'Nishit',
  brandBottom: 'Thakkar',
  topBar: '1-to-1 Consulting · Manifestation Meets Business Implementation\u2122 \u2192',
  authorImage: '/images/author.jpg',
  bookCover: '/images/book-cover.jpg',
  promoArt: '/images/book-promo.jpg',
  formulaImage: 'https://customer-assets.emergentagent.com/job_nishit-portfolio/artifacts/b8we3hc4_ChatGPT%20Image%20May%2031%2C%202026%2C%2004_23_53%20PM.png',
};

export const NAV = [
  { label: 'Home', href: '#home' },
  { label: 'Program', href: '#program' },
  { label: 'Book', href: '/book' },
  { label: 'About', href: '#about' },
];

export const HERO = {
  kicker: '1-to-1 Money Manifestation Consulting',
  title_a: 'Manifestation Meets',
  title_b: 'Business Implementation\u2122',
  subtitle:
    'Inner Alignment + Strategic Action = Quantum Growth\u2122. We install the exact subconscious blueprint that helps ambitious souls break their income ceiling — private, 1-to-1, built for those done chasing wealth and ready to command it.',
  cta: 'Apply for 1-to-1 Consulting',
};

export const ABOUT = {
  heading: 'Why We Built\nQuantum Shift Formula',
  body: "Most manifestation content online is recycled fluff — vague affirmations and surface-level 'think positive' advice that never moves the needle on your bank account. We built Quantum Shift Formula (QSF) the hard way: 15+ years of inner work, thousands of consulting hours, and a tested system that actually rewires the money mind. In this 1-to-1 program, we don't 'teach theory' — we install the exact mindset, energy, and action systems straight into your life, driving real shifts from Day 1. Reading is good, but not enough — if you want to win faster, cleaner, and command wealth at scale, you're in the right place.",
};

export const PILLARS_HEADING = 'Where the Ambitious\nRewire Their Wealth';
export const PILLARS_SUB =
  "QSF (Quantum Shift Formula) isn't for the curious. It's the private advisory for ambitious souls already moving — and ready to command wealth at the next level.";

export const PILLARS = [
  {
    icon: 'Sparkles',
    title: '1-to-1 Consulting',
    desc: "If you're done with group programs and ready for deep work — we'll install the exact subconscious blueprint that compounds wealth.",
    badge: 'Flagship',
  },
  {
    icon: 'BookOpenText',
    title: 'You Are The Magician',
    desc: 'The 100+ page manifestation manual — real assignments, real shifts, real money. The book that rewires your money mind.',
    badge: 'Book',
  },
  {
    icon: 'Crown',
    title: 'Private Intensives',
    desc: 'By invitation only — high-touch 2-day immersions for clients ready to engineer their wealth identity in person.',
    badge: 'Invite Only',
  },
  {
    icon: 'Infinity',
    title: 'Coming Soon',
    desc: 'The next evolution of the consulting program — a private community of wealth-aligned operators.',
    badge: 'Soon',
  },
];

export const STATS = [
  { label: 'Years of Practice', value: '15+', delta: '+ counting' },
  { label: 'Lives Transformed', value: '10K+', delta: 'across India' },
  { label: 'Consulting Hours', value: '5,000+', delta: '1-to-1 only' },
  { label: 'Reader Rating', value: '4.9 / 5', delta: 'on the book' },
  { label: 'Refund Rate', value: '< 1%', delta: 'industry low' },
  { label: 'Signature Method', value: 'QSF\u2122', delta: 'Inner Alignment + Action' },
];

export const ACHIEVEMENTS = [
  {
    tag: 'Our USP',
    title: 'Manifestation Meets Business Implementation\u2122',
    desc: 'Transform your inner reality. Build your business systems. Create measurable growth. Inner Alignment + Strategic Action = Quantum Growth\u2122.',
  },
  {
    tag: 'The 7 Shifts',
    title: '7 Subconscious Shifts. One New Life.',
    desc: 'Reprogram the mind, align energy, dissolve fear, install the wealth identity, and build compounding income streams.',
  },
  {
    tag: '1-to-1 Only',
    title: 'No Group Calls. No Cohorts.',
    desc: "Every session is private. Every blueprint is personal. Because your money story isn't a template.",
  },
  {
    tag: 'The Book',
    title: '"You Are The Magician" \u2014 100+ Pages',
    desc: 'A practical manual, not motivation. Each chapter pairs a principle with an actionable assignment you actually do.',
  },
  {
    tag: 'Built On Wisdom',
    title: '15 Years \u2022 Astrology \u2022 Vastu \u2022 Numerology',
    desc: 'Ancient frameworks meet modern psychology \u2014 turning abstract spiritual ideas into repeatable, grounded practice.',
  },
  {
    tag: 'World No. 1',
    title: "World's No. 1 Money Manifestation Program",
    desc: 'Engineered for ambitious souls who are tired of recycled advice and ready for a system that actually moves the needle.',
  },
];

export const FORMULA = {
  heading: 'The 3-Step\n30-Day Formula',
  sub: 'Mindset. Alignment. Action. Wealth. \u2014 30 days to transform your mind, multiply your income, and create lasting wealth.',
  steps: [
    {
      n: '01',
      days: 'Days 1\u201310',
      title: 'Diagnose & Dissolve',
      sub: "Clear what's holding you back.",
      bullets: [
        { t: 'Belief Audit', d: 'Identify limiting beliefs and outdated patterns.' },
        { t: 'Fear Map', d: 'Uncover hidden fears and self-sabotage.' },
        { t: 'Dissolve & Reset', d: 'Release what no longer serves you and reset your energy.' },
      ],
      outcome: 'Mental clarity, emotional freedom, and a new foundation.',
      tone: 'violet',
    },
    {
      n: '02',
      days: 'Days 11\u201320',
      title: 'Install & Align',
      sub: 'Become who you need to be.',
      bullets: [
        { t: 'Identity Upgrade', d: 'Adopt a high-value identity aligned with wealth.' },
        { t: 'Visualise', d: 'See it, feel it, believe it \u2014 wire your subconscious.' },
        { t: 'Align Energy', d: 'Align thoughts, emotions and actions with your goals.' },
      ],
      outcome: 'New identity, strong inner alignment, unshakeable confidence.',
      tone: 'sky',
    },
    {
      n: '03',
      days: 'Days 21\u201330',
      title: 'Act & Multiply',
      sub: 'Take action. Create wealth.',
      bullets: [
        { t: 'Action Plan', d: 'Take focused, inspired action daily.' },
        { t: 'Income Streams', d: 'Build and activate one or more income streams.' },
        { t: 'Multiply & Scale', d: 'Optimise, automate and scale for abundance.' },
      ],
      outcome: 'Real results, growing income and financial freedom on repeat.',
      tone: 'emerald',
    },
  ],
  equation: ['Clear Mind', 'Aligned Heart', 'Consistent Action', 'Financial Freedom'],
};

export const TESTIMONIALS_HEADING = {
  pre: 'What People Say About',
  main: 'Quantum Shift Formula (QSF)',
};

export const QSF_TESTIMONIALS = [
  {
    name: 'Jay Thakkar',
    role: 'SAP Consultant, TCS',
    quote:
      'Quantum Shift Formula is truly inspiring and easy to understand. QSF beautifully explains how our thoughts, energy, beliefs, and actions shape our lives and results. What I particularly like is the practical guidance. The concepts can actually be applied in daily life to build a more positive mindset, work towards abundance, and become more intentional about the results we want to create. The entire journey is structured in a way that keeps you engaged and excited to implement the next step. A great program for anyone looking to improve themselves, grow, and create meaningful change in their life.',
  },
  {
    name: 'Suchit Shah',
    role: 'Co-Founder, Neo Progress & Neo Algo',
    quote:
      'Quantum Shift Formula is a compelling and structured transformation program that brings together mindset psychology, manifestation principles, subconscious conditioning, and practical financial and growth behaviour into one cohesive framework. The concept of the \u2018financial thermostat\u2019 is particularly impactful and relatable. QSF doesn\u2019t stop at thinking differently. It pushes you to implement, take aligned action, and create measurable shifts in the way you operate.',
  },
  {
    name: 'Dr. Priti Patel',
    role: 'Orion Dental Clinic',
    quote:
      'Going through Quantum Shift Formula genuinely changed the way I think about myself and my life. One concept that really stayed with me is visualization. Instead of constantly thinking, \u2018Can I do this?\u2019, QSF teaches you to visualize yourself already becoming the person capable of achieving the result. My biggest takeaway is that transformation begins within us. QSF is not something you simply learn — it is something you experience, practise, and implement.',
  },
  {
    name: 'Shailii Patel',
    role: 'Hrim Safar',
    quote:
      'Quantum Shift Formula creates an interesting connection between spirituality, energy, mindset, and practical wealth-building principles. The concepts of \u2018wealth identity\u2019 and the internal financial thermostat are insightful and highly relatable. QSF places a strong emphasis on aligned action, making it clear that manifestation is not simply about visualization — it also requires consistent effort and implementation. Highly recommended!',
  },
  {
    name: 'Kushal Dham',
    role: 'Soundsphere',
    quote:
      'Quantum Shift Formula is not just about manifestation — it is a mindset and identity shift. It explains in a simple yet powerful way how our thoughts, beliefs, energy, and actions influence our financial and personal reality. For anyone looking to identify limiting beliefs, work on their subconscious patterns, and move towards greater abundance with action, QSF can be a powerful transformational journey.',
  },
  {
    name: 'Mihir Mehta',
    role: 'Royal Technosoft',
    quote:
      'QSF beautifully explains that abundance is not merely something to chase — it is something we need to become internally aligned with while taking the right actions externally. What makes the program valuable is that it provides practical tools and implementation exercises instead of remaining purely theoretical. It is designed for people looking for transformation rather than temporary motivation.',
  },
  {
    name: 'Shoyeb Saiyed',
    role: 'Synobiz Systems',
    quote:
      'Quantum Shift Formula is a refreshing and practical approach to personal and financial growth. It combines mindset, energy, identity, manifestation, and action in a way that feels logical and actionable. The exercises and implementation practices make the concepts easier to apply immediately instead of simply understanding them intellectually. QSF feels like a framework for upgrading the way you think, operate, and approach growth in your life.',
  },
  {
    name: 'Sanjay Chavda',
    role: 'Chavda Group of Companies',
    quote:
      "What I appreciate about QSF is that it doesn't position manifestation as a shortcut or magic trick. Instead, it teaches you to become the source of change by working on your identity, subconscious patterns, fears, beliefs, decisions, and actions. QSF encourages you to take greater responsibility for your growth while providing a structured process for doing something about it.",
  },
  {
    name: 'T. R. Keshav',
    role: 'Fundflow Consultancy',
    quote:
      'QSF simplifies concepts such as manifestation, subconscious programming, beliefs, and energy into practical steps that can be implemented. The concept of \u2018aligned action\u2019 is particularly important because it clears up one of the biggest misconceptions around manifestation. I would especially recommend it to entrepreneurs, professionals, and growth-minded individuals who want to work on both their internal mindset and external results.',
  },
  {
    name: 'Rajat Patel',
    role: '',
    quote:
      "Quantum Shift Formula is a powerful combination of psychology, mindset, manifestation, subconscious work, and real-world action. The concepts are communicated in a direct, engaging, and easy-to-understand manner. The biggest difference is that you don't simply learn new concepts — you begin observing your own thinking, beliefs, behaviour, and actions differently.",
  },
  {
    name: 'Smita Davda',
    role: 'Charvika Advisory Services',
    quote:
      'QSF does an excellent job of explaining how subconscious programming can influence our financial behaviour and results. The \u2018financial thermostat\u2019 concept is incredibly relatable and eye-opening. Understanding those internal patterns — and then consciously working on changing them — makes QSF highly practical and insightful.',
  },
  {
    name: 'Nidhi Chandel',
    role: 'Varuni Systems',
    quote:
      'Quantum Shift Formula is not typical motivational or manifestation training — it is a structured approach to self-mastery and implementation. The exercises, assignments, and practices make the journey interactive and encourage you to actually work on yourself rather than simply feel motivated for a few days. It is a valuable program for anyone serious about personal, professional, and financial growth.',
  },
];

export const FAQ_BLURB = {
  heading: 'Ready to Stop Chasing\nand Start Commanding?',
  sub: "We don't chase clients \u2014 we choose them. And if you're the right fit, this will be the single most valuable inner work of your life.",
  cta: 'Apply for 1-to-1 Consulting',
};
